const INITIAL_STATE = {
  errors: {},
  getCustomer: {},
  updateCustomer: {},
  deleteCustomer: {},
  addGuestUser: {},
  updateGuestUser: {},
  deleteGuestUser: {},
  list: {},
  serviceRepairRequest: {},
  serviceAgreementList: {},
  addServiceAgreement: {},
  deleteServiceAgreement: {},
  updateServiceLineItem: {},
  bdaList: {}
}

const customer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_COMMERCIAL_CUSTOMER_LIST':
    return { ...state, ...INITIAL_STATE, list: action.data }
  case 'GET_COMMERCIAL_CUSTOMER_LIST_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'GET_COMMERCIAL_CUSTOMER':
    return { ...state, ...INITIAL_STATE, getCustomer: action.data }
  case 'GET_COMMERCIAL_CUSTOMER_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'UPDATE_COMMERCIAL_CUSTOMER':
    return { ...state, ...INITIAL_STATE, updateCustomer: action.data }
  case 'UPDATE_COMMERCIAL_CUSTOMER_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'DELETE_COMMERCIAL_CUSTOMER':
    return { ...state, ...INITIAL_STATE, deleteCustomer: action.data }
  case 'DELETE_COMMERCIAL_CUSTOMER_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'ADD_GUEST_USER':
    return { ...state, ...INITIAL_STATE, addGuestUser: action.data }
  case 'ADD_GUEST_USER_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'UPDATE_GUEST_USER':
    return { ...state, ...INITIAL_STATE, updateGuestUser: action.data }
  case 'UPDATE_GUEST_USER_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'DELETE_GUEST_USER':
    return { ...state, ...INITIAL_STATE, deleteGuestUser: action.data }
  case 'DELETE_GUEST_USER_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'REQUEST_REPAIR':
    return { ...state, ...INITIAL_STATE, serviceRepairRequest: action.data }
  case 'REQUEST_REPAIR_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'SERVICE_AGREEMENT_LIST':
    return { ...state, ...INITIAL_STATE, serviceAgreementList: action.data }
  case 'SERVICE_AGREEMENT_LIST_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'ADD_SERVICE_AGREEMENT':
    return { ...state, ...INITIAL_STATE, addServiceAgreement: action.data }
  case 'ADD_SERVICE_AGREEMENT_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'DELETE_SERVICE_AGREEMENT':
    return { ...state, ...INITIAL_STATE, deleteServiceAgreement: action.data }
  case 'DELETE_SERVICE_AGREEMENT_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'UPDATE_SERVICE_LINE_ITEM':
    return { ...state, ...INITIAL_STATE, updateServiceLineItem: action.data}
  case 'UPDATE_SERVICE_LINE_ITEM_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'GET_BDA':
    return { ...state, ...INITIAL_STATE, bdaList: action.data}
  case 'GET_BDA_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};

export default customer;
